import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ui from 'redux-ui';
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import Dialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/Dialog';
import DialogActions from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogActions';
import DialogContent from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogContent';
import DialogTitle from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogTitle';
import Close from 'housecall-ui/dist/IconsAndImages/Icons/Close';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import IconButton from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/IconButton';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import { isPresent } from 'utils/isPresent';

export const SUCCESS_TEXT = 'SUCCESS_TEXT';

@ui({
  state: {
    successText: '',
    successAction: null,
    secondaryButtonText: '',
    secondaryButtonAction: null,
    titleText: '',
    primaryButtonText: '',
    open: false,
  },
  reducer: (state, action) => {
    switch (action.type) {
      case SUCCESS_TEXT:
        return state.set('successText', action.successText)
          .set('successAction', action.successAction)
          .set('secondaryButtonText', action.secondaryButtonText)
          .set('secondaryButtonAction', action.secondaryButtonAction)
          .set('titleText', action.titleText)
          .set('primaryButtonText', action.primaryButtonText)
          .set('open', isPresent(action.successText) || isPresent(action.titleText));
    }
    return state;
  },
})

export default class SuccessDialog extends Component {
  closeDialog() {
    const { updateUI } = this.props;
    updateUI('open', false);
  }

  renderSecondaryButton() {
    const { ui: { secondaryButtonText, secondaryButtonAction }} = this.props;
    if (isPresent(secondaryButtonText) && isPresent(secondaryButtonAction)) {
      return (
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => {
            this.closeDialog();
            secondaryButtonAction();
          }}
        >
          {secondaryButtonText}
        </Button>
      );
    }
  }

  render() {
    const {
      ui: {
        open,
        titleText = 'Success',
        successText,
        successAction,
        primaryButtonText,
      },
    } = this.props;

    return (
      <HousecallThemeProvider>
        <Dialog
          fullWidth
          style={{ zIndex: 2000 }}
          open={open}
          disableEnforceFocus
        >
          <Grid container justify="space-between">
            <Grid item xs={10} sm={11}>
              <DialogTitle id="simple-dialog-title">{ titleText }</DialogTitle>
            </Grid>
            <Grid item>
              <IconButton
                size="small"
                onClick={() => {
                  this.closeDialog();
                }}
              >
                <Close />
              </IconButton>
            </Grid>
          </Grid>
          <DialogContent>
            <Typography style={{ whiteSpace: 'pre-line' }}>
              { successText }
            </Typography>
          </DialogContent>
          <DialogActions>
            {this.renderSecondaryButton()}
            <Button
              autoFocus
              variant="contained"
              color="primary"
              onClick={() => {
                this.closeDialog();
                successAction();
              }}
            >
              { primaryButtonText || 'OK' }
            </Button>
          </DialogActions>
        </Dialog>
      </HousecallThemeProvider>
    );
  }
}

SuccessDialog.propTypes = {
  ui: PropTypes.shape({
    titleText: PropTypes.string,
    primaryButtonText: PropTypes.string,
    secondaryButtonText: PropTypes.string,
    successText: PropTypes.string,
    secondaryButtonAction: PropTypes.func,
    successAction: PropTypes.func,
    open: PropTypes.bool,
    updateUI: PropTypes.func,
  }),
};

SuccessDialog.defaultProps = {
  ui: {
    titleText: '',
    primaryButtonText: '',
    secondaryButtonText: '',
    successText: '',
    secondaryButtonAction: null,
    successAction: null,
    open: false,
    updateUI: null,
  },
};
